import { Avatar, Box, Flex, Text, Stack } from "@chakra-ui/react";
import React from "react";

export default function MessageHandler({ reply, imageUrl, time, messages }) {
  //messages should be an array
  return (
    <Flex
      flexDir={reply ? "row" : "row-reverse"}
      gap={{ base: 1, md: 2 }}
      my={{ base: 1, md: 2 }}
      mr={2}
    >
      <Box>
        <Avatar src={imageUrl} size={{ base: "sm", md: "md", lg: "lg" }} />
      </Box>
      <Stack alignItems={reply ? "start" : "end"} gap={2}>
        {messages?.map((item) => {
          return (
            <Text
              p={{ base: 2, md: 5 }}
              bg="#E4F3FB"
              key={item}
              maxW={{ base: "70%", md: "60%" }}
            >
              {item}
            </Text>
          );
        })}
        <Text>{time}</Text>
      </Stack>
    </Flex>
  );
}
